import Vacancy from './Vacancy.vue';

export default Vacancy;



// WEBPACK FOOTER //
// ./src/pages/profile/views/vacancy/index.ts